const React = require("react");

function PlusSmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  }));
}

module.exports = PlusSmIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/PlusSmIcon.js
 ** module id = 587
 ** module chunks = 0
 **/